import {createSlice} from '@reduxjs/toolkit';

const initialState = {
   isPageReload: true,
   courseData: null,
   parseJsonData: null,
   moduleCompetedCount: 0,
};

const EnrolledCourseDataSlice = createSlice({
   name: 'enrolledCourseData',
   initialState,
   reducers: {
      setIsEnrolledPageReload: (state, action) => {
         state.isPageReload = action.payload;
      },
      setCourseData: (state, action) => {
         state.courseData = action.payload;
      },
      setParseJsonData: (state, action) => {
         state.parseJsonData = action.payload;
      },
      setModuleCompetedCount: (state, action) => {
         state.moduleCompetedCount = action.payload;
      },
   },
});

export const {setIsEnrolledPageReload} = EnrolledCourseDataSlice.actions;
export const {setCourseData} = EnrolledCourseDataSlice.actions;
export const {setParseJsonData} = EnrolledCourseDataSlice.actions;
export const {setModuleCompetedCount} = EnrolledCourseDataSlice.actions;
export const getEnrollPageReload = state =>
   state.enrolledCourseData.isPageReload;
export const getCourseData = state => state.enrolledCourseData.courseData;
export const getParseJsonData = state => state.enrolledCourseData.parseJsonData;
export const getModuleCompetedCount = state =>
   state.enrolledCourseData.moduleCompetedCount;
export default EnrolledCourseDataSlice.reducer;
